<template>
  <div>
    <Mainl></Mainl>
    <div class="page_content">
      <div class="service_team_content">
        <div class="service_team_content_title">公司信息管理</div>
        <div class="service_team_content_company_name" v-show="Type==2">{{ Company }}</div>
        <div class="service_team_content_company_info"  v-if="Type==2"> <!-- 公司 -->
          <div class="service_team_content_company_item">
            <span class="service_team_content_company_item_label">公司名称：</span>
            <span class="service_team_content_company_item_value">{{ Company }}</span>
          </div>
          <div class="service_team_content_company_item">
            <span class="service_team_content_company_item_label">姓名：</span>
            <span class="service_team_content_company_item_value">{{ Name }}</span>
          </div>
          <div class="service_team_content_company_item">
            <span class="service_team_content_company_item_label">用户名：</span>
            <span class="service_team_content_company_item_value">{{ Username }}</span>
          </div>
          <div class="service_team_content_company_item" >
            <span class="service_team_content_company_item_label">团队规模：</span>
            <span class="service_team_content_company_item_value">{{ TeamSize}}</span>
          </div>
          <div class="service_team_content_company_item">
            <span class="service_team_content_company_item_label">地区：</span>
            <span class="service_team_content_company_item_value">{{province_city_name}}</span>
          </div>
          <div class="service_team_content_company_item">
            <span class="service_team_content_company_item_label">是否提供驻场服务：</span>
            <span class="service_team_content_company_item_value">{{ IsOnsite }}</span>
          </div>
          <div class="service_team_content_company_item">
            <span style="margin-right: 14px;" class="service_team_content_company_item_label">手机号：</span>
            <span class="service_team_content_company_item_value">{{ Telphone }}</span>
          </div>
          <div class="service_team_content_company_item">
            <span class="service_team_content_company_item_label">邮箱：</span>
            <span class="service_team_content_company_item_value">{{ Email }}</span>
          </div>
          <div class="service_team_content_company_item">
            <span class="service_team_content_company_item_label">擅长行业：</span>
            <span class="service_team_content_company_item_value">{{ GoodAtTopIndustry ? GoodAtTopIndustry : '' }}</span>
          </div>
          <div class="service_team_content_company_item">
            <span class="service_team_content_company_item_label">擅长业务领域：</span>
            <span class="service_team_content_company_item_value">{{ GoodAtTopCategory ? GoodAtTopCategory : '' }}</span>
          </div>
          <div class="service_team_content_company_item">
            <span class="service_team_content_company_item_label">服务过的客户：</span>
            <span class="service_team_content_company_item_value">{{ ServiceBrand ? ServiceBrand : '' }}</span>
          </div>
        </div>
        <div class="service_team_content_company_info service_team_content_person_info" v-else>  <!-- 个人 -->
          <div class="service_team_content_company_item">
            <span class="service_team_content_company_item_label">姓名：</span>
            <span class="service_team_content_company_item_value">{{ Name }}</span>
          </div>
          <div class="service_team_content_company_item">
            <span class="service_team_content_company_item_label">用户名：</span>
            <span class="service_team_content_company_item_value">{{ Username }}</span>
          </div>
          <div class="service_team_content_company_item">
            <span class="service_team_content_company_item_label">地区：</span>
            <span class="service_team_content_company_item_value">
              {{ province_city_name }}
            </span>
          </div>
          <div class="service_team_content_company_item">
            <span class="service_team_content_company_item_label">是否提供驻场服务：</span>
            <span class="service_team_content_company_item_value">{{ IsOnsite }}</span>
          </div>
          <div class="service_team_content_company_item">
            <span  class="service_team_content_company_item_label">手机号：</span>
            <span class="service_team_content_company_item_value">{{ Telphone }}</span>
          </div>
          <div class="service_team_content_company_item">
            <span class="service_team_content_company_item_label">邮箱：</span>
            <span class="service_team_content_company_item_value">{{ Email }}</span>
          </div>
          <div class="service_team_content_company_item">
            <span class="service_team_content_company_item_label">擅长行业：</span>
            <span class="service_team_content_company_item_value">{{ GoodAtTopIndustry ? GoodAtTopIndustry : '' }}</span>
          </div>
          <div class="service_team_content_company_item">
            <span class="service_team_content_company_item_label">擅长业务领域：</span>
            <span class="service_team_content_company_item_value">{{ GoodAtTopCategory ? GoodAtTopCategory : '' }}</span>
          </div>
          <div class="service_team_content_company_item">
            <span class="service_team_content_company_item_label">服务过的客户：</span>
            <span class="service_team_content_company_item_value">{{ ServiceBrand ? ServiceBrand : '' }}</span>
          </div>
      </div>
        <div class="service_team_content_tabll_wrap">
          <div class="service_team_content_tabll_title">附件信息</div>
          <el-table :data="companyInfo.annexlist" style="width: 100%" class="table_warp">
            <el-table-column prop="username" label="上传人" align="center">
            </el-table-column>
            <el-table-column label="附件名称">
              <template v-slot="scope">
                <el-link style="color:#4573ff" :href="scope.row.url " target="_blank">{{ scope.row.filename }}</el-link>
              </template>
            </el-table-column>
            <el-table-column prop="datetime" label="上传时间">
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
  import Mainl from '@/components/Mainl.vue'
  import Cookies from "js-cookie";
  import * as commfun from "@/common/common.js"
  import index_mixins_shengshi from "@/common/mixins/index_mixins_shengshi.js"

  // import index_mixins_page from "@/common/index_mixins_page.js"
  export default {
    name: 'Index',
    mixins: [index_mixins_shengshi],
    components: {
      Mainl,
    },
    data: function () {
      return {
        Type:0,
        Company:"",
        Name:"",
        Username:"",
        TeamSize:"",
        //Area:"",
        IsOnsite:"",
        Telphone:"",
        Email:"",
        GoodAtTopCategory: "",
        GoodAtTopIndustry: "",
        ServiceBrand: "",
        companyInfo: {},
        dict: {},
        shengshi_data: {},//省市数据
        overseas_area_dict: {},//海外地区字典
        team_size_dict: {},//团队规模字典
        DicFileTypes: {},//附件类型字典
        regional_scope:1,//1国内，2海外
        province_city_name:""
      };
    },
    mounted() {
      //省市数据加载
      this.getShengShi();
      this.get_dict()
      setTimeout(() => {
        this.initData()
      }, 100)
      // this.initData()
    },

    methods: {
       /** 省市快捷搜索结束 */
       handleChange(value) {
          var province =  this.getNameByCode(value[0]);
          var city =  this.getNameByCode(value[1]);
          return  province+'/'+city;
       },
      // 获取字典
      get_dict() {
        var selfthis = this;
        var url = '/api/api/user/dict';
        var postdata = {}
        commfun.ajaxGet(selfthis, url, postdata, function (selfthis, result) {
          selfthis.overseas_area_dict = result.overseas_area_dict
          selfthis.team_size_dict = result.one_team_size_dict
          selfthis.DicFileTypes = result.annex_dict
        }, function (selfthis, dataError) {
          commfun.showMessage(selfthis, 'warning', '字典查询错误，请联系管理员')
        })


      },
      // 获取数据
      initData: function () {
        var selfthis = this
        var url = '/api/api/user/ajaxUserInfo'
        var postdata = {}
        commfun.ajaxPost(selfthis, url, postdata, function (selfthis, data) {
          console.log(data)
          selfthis.companyInfo = data
          selfthis.Company = data.user.Company
          selfthis.Name = data.user.Name
          selfthis.Username = data.user.Username
          selfthis.TeamSize = data.user.TeamSize?selfthis.team_size_dict[data.user.TeamSize]:''
          selfthis.IsOnsite = data.user.IsOnsite
          selfthis.Telphone = data.user.Telphone
          selfthis.GoodAtTopCategory = data.user.GoodAtTopCategory
          selfthis.GoodAtTopIndustry = data.user.GoodAtTopIndustry
          selfthis.ServiceBrand = data.user.ServiceBrand
          selfthis.Email = data.user.Email
          selfthis.Type = data.user.Type
          selfthis.regional_scope = data.user.RegionalScope
          //console.log(selfthis.regional_scope )
          if (selfthis.regional_scope == 1) {
                //var areas = selfthis.Area.split(',')
                //selfthis.province_city_name = "国内/"+selfthis.handleChange(areas)
                selfthis.province_city_name = "国内/"+selfthis.getShengShiInfoByCode(data.user.Area)

          }else if(selfthis.regional_scope == 2){
            var overstr=""
            for(var i in selfthis.overseas_area_dict){
              if(selfthis.overseas_area_dict[i]['dic_key']==data.user.Area){
                overstr = selfthis.overseas_area_dict[i]['dic_value']
              }
            }
            selfthis.province_city_name = "海外/"+overstr
          }


        }, function (selfthis, dataError) {
          commfun.showMessage(selfthis, 'warning', '错误：' + dataError.msg)
        })
      },
    },

  }
</script>



// WEBPACK FOOTER //
// src/components/Company.vue